export default __webpack_public_path__ + "52e1679865f7fd43df22d550f8a139cd.svg";